import { BaseGameDrawer } from './BaseGameDrawer';
import { GameDrawer } from '../GameDrawer';
import { getResourceChunks } from '../../components/loading/loadPerChunk';
import { webSources } from '../../core/resources';
import { loadingStageService } from '../../components/loading/LoadingStageService';
import { sharedSourceNames } from '../../core/sourceNames';
import { ballHelper } from '../../core/ball/ballHelper';

export class GameWebDrawer extends BaseGameDrawer {
  constructor(drawers) {
    super(drawers);
    this.ressourceLoaded = null;
  }

  async loadResource() {
    if (!this.ressourceLoaded && !GameDrawer.resources) {
      const resources = getResourceChunks(webSources);
      GameDrawer.resources = {};
      this.ressourceLoaded = Promise.all([
        this.drawers.gamePad.application.loadResource().then(() => loadingStageService.next()),
        ...resources.map(sources => {
          return super.loadResource(sources, this.createLoader()).then(({ res }) => {
            if (res[sharedSourceNames.balls]) {
              ballHelper.setResource(res[sharedSourceNames.balls]);
            }
            GameDrawer.resources = {
              ...GameDrawer.resources,
              ...res,
            };
            loadingStageService.next();
          });
        }),
      ]);
    }
    await this.ressourceLoaded;
  }
}